/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./luckylotterylogs.vue?vue&type=template&id=3b8ea52e&scoped=true"
import script from "./luckylotterylogs.vue?vue&type=script&lang=js"
export * from "./luckylotterylogs.vue?vue&type=script&lang=js"
import style0 from "./luckylotterylogs.vue?vue&type=style&index=0&id=3b8ea52e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b8ea52e",
  null
  
)

export default component.exports